import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { queryClient } from '../../App';

const EnableCategoriesModal = ({
    show = false,
    setShow,
    custom_categories = {},
    default_categories = {},
    checkedItems=[],
    setCheckedItems=()=>{},
    mutate,
    restaurant_id
}) => {
    const [tab, setTab] = useState("default");
    const [enabling,setEnabling]=useState(false);


    const categories = tab === 'default' ? default_categories : custom_categories;

    // 🧱 Build a map of child value -> parent value
    const buildParentMap = (tree, parent = null, map = {}) => {
        for (const node of tree) {
            map[node.value] = parent;
            if (node.children) {
                buildParentMap(node.children, node.value, map);
            }
        }
        return map;
    };
function findParentsInData(data, childValue) {
    function search(nodes) {
        for (const node of nodes) {
            if (node.value === childValue) {
                return [node.value];
            }
            if (node.children) {
                const childPath = search(node.children);
                if (childPath) {
                    return [node.value, ...childPath];
                }
            }
        }
        return null;
    }

    for (const key in data) {
        if (Array.isArray(data[key])) {
            const result = search(data[key]);
            if (result) return result;
        }
    }
    return [];
}
function removeFromChecked(data, id, checkedItems) {
    function findNode(nodes, targetId) {
        for (const node of nodes) {
            if (node.value === targetId) return node;
            if (Array.isArray(node.children)) {
                const result = findNode(node.children, targetId);
                if (result) return result;
            }
        }
        return null;
    }

    function hasAnyCheckedDescendants(node, checkedSet) {
        if (!node || !Array.isArray(node.children)) return false;
        for (const child of node.children) {
            if (checkedSet.has(child.value)) return true;
            if (hasAnyCheckedDescendants(child, checkedSet)) return true;
        }
        return false;
    }

    const allRootNodes = Object.values(data).flat();
    const updated = new Set(checkedItems);

    const targetNode = findNode(allRootNodes, id);
    if (!targetNode) return checkedItems;

    // Remove the unchecked item
    updated.delete(id);

    // Walk from the node up to its ancestors
    const path = findParentsInData(data, id); // Example: ['Alcoholic Beverage', 'Beer', 'Draft Beer']

    // We go from the deepest parent up to the top
    for (let i = path.length - 2; i >= 0; i--) {
        const parentId = path[i];
        const parentNode = findNode(allRootNodes, parentId);

        if (parentNode && !hasAnyCheckedDescendants(parentNode, updated)) {
            updated.delete(parentId);
        }
    }

    return Array.from(updated);
}

const handleCheck = (checked, id) => {
    setCheckedItems(prev => {
        if (checked) {
            const newItems = [...new Set([...prev, ...findParentsInData(categories, id)])];
            return newItems;
        } else {
            return removeFromChecked(categories, id, prev);
        }
    });
};

const renderNode = (node) => {
        const isLeaf = !node.children || node.children.length === 0;
        const isEnabled = node.active // active category

        return (
            <div key={node.value} style={{ marginLeft: "20px", marginTop: "5px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <input
                        type="checkbox"
                        checked={checkedItems?.find((id) => id == node?.value) || isEnabled} // show filled if enabled
                        // disabled={!isLeaf}
                        onChange={(e) => handleCheck(e.target.checked, node.value)}
                        style={{
                            accentColor: isEnabled ? "green" : "blue", // ✅ green for enabled, blue otherwise
                            cursor: isEnabled ? "not-allowed" : "pointer"
                        }}
                    />
                    <span style={{ fontSize: "13px", color: isEnabled ? "var(--bs-secondary-color)" : "var(--bs-body-color)" }}>{node.title}</span>
                </div>
                {node.children && node.children.length > 0 && (
                    <div>
                        {node.children.map(child => renderNode(child))}
                    </div>
                )}
            </div>
        );
    };

    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            backdrop="static"
            keyboard={false}
            centered
            size="md"
        >
            <Modal.Header closeButton>
                <Modal.Title>Enable Categories</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
                    <button
                        onClick={() => setTab("default")}
                        className={`btn ${tab === "default" ? "btn-success" : "border"} rounded-1 btn-sm`}
                        style={{ fontSize: "12px", paddingTop: "5px", paddingBottom: "5px" }}
                    >
                        Default Categories
                    </button>
                    <button
                        onClick={() => setTab("custom")}
                        className={`btn ${tab === "custom" ? "btn-success" : "border"} rounded-1 btn-sm`}
                        style={{ fontSize: "12px", paddingTop: "5px", paddingBottom: "5px" }}
                    >
                        Custom Categories
                    </button>
                </div>

                <div className='my-3 border' style={{ display: "flex", flexDirection: "column", maxHeight: "400px", overflowY: "auto" }}>
                    {Object.keys(categories)
                        .filter(topKey => ["menu", "labor", "discount"].includes(topKey)) // ✅ only show these
                        .map((topKey) => (
                            <div key={topKey} style={{ marginBottom: "10px" }}>
                                <span style={{ textTransform: "capitalize", padding: "5px" }}>{topKey}</span>
                                {categories[topKey].map(item => renderNode(item))}
                            </div>
                        ))}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={() => {
                    setShow(false);
                    setCheckedItems([]);
                    setTab("default")
                }}>Cancel</button>
                <button
                    className="btn btn-success"
                    onClick={() => {
                       setEnabling(true);
                       mutate({restaurant_id,category_ids:checkedItems},{
                        onSuccess:()=>{
                            setEnabling(false);
                            queryClient.invalidateQueries({ queryKey: ["restaurant-category-detail"] });
                            setCheckedItems([]);
                            setShow(false);
                            
                        },
                        onError:()=>{
                            setEnabling(false);
                            
                        }
                       })
                    
                    }}
                >
                    {enabling?"Enabling...":"Enable "}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default EnableCategoriesModal;
